import React from "react";
import { StateroomsMap } from "../../utils/helperFunctions/Stateroom";
import { formatUSAmount } from "../../utils/helperFunctions/helperFunctions";

const CartItemStateroom = ({ item, onRemove, parent }) => {
  // const bookingDetails = useSelector((state) => state.bookingValidation.data);

  //   var { min_qty, max_qty } = getSuppCartAddCondition(
  //     bookingDetails,
  //     item.supplement.Selection_method
  //   );

  //   if (item.supplement.child?.Selection_method) {
  //     var { child_min_qty, child_max_qty } = getSuppCartAddCondition(
  //       bookingDetails,
  //       item.supplement.child.Selection_method
  //     );
  //   }

  return (
    <div className="flex sm:flex-col lg:flex-row items-center justify-between w-full p-4 border-b border-[#6699C2]">
      <div className="flex w-full gap-2">
        <img
          src={
            `${process.env.PUBLIC_URL}/assets/UpgradeStateroom/Staterooms/` +
            (StateroomsMap[item.stateroom.category_name]?.img_name[0] ||
              StateroomsMap.default.img_name) +
            ".jpg"
          }
          alt={item.stateroom.category_name}
          className="w-24 h-24 object-cover"
        />
        <div className="flex-1 w-full ml-4 mt-4">
          <div className="w-full gap-2 flex-col-reverse md:flex-row flex justify-between">
            <div>
              {" "}
              <h3 className="text-xl font-semibold text-blue-900">
                New Cabin - {item.stateroom.category_name}
              </h3>
              <h3 className="text-xl font-semibold text-blue-900">
                Previous Cabin -{" "}
                {item.prev_cabin.room_no + " " + item.prev_cabin.category_name}
              </h3>
            </div>
            <div className="flex md:flex-col gap-4 justify-between md:justify-normal items-end space-x-4">
              <p className="text-xl font-semibold text-blue-900">
                ${formatUSAmount(item.stateroom.diff_price)}
              </p>
              {parent !== "cartPreview" && (
                <button
                  onClick={() =>
                    onRemove(item?.prev_cabin.room_id, "stateroom")
                  }
                  className="text-red-500 hover:text-red-700"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5-4h4a2 2 0 012 2v2H8V5a2 2 0 012-2zm-7 6h18"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItemStateroom;
